(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .factory('PaynetModeSearch', PaynetModeSearch);

    PaynetModeSearch.$inject = ['$resource'];

    function PaynetModeSearch($resource) {
        var resourceUrl =  'api/_search/paynet-modes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
